import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-cream min-h-screen flex items-center overflow-hidden pt-6 pb-10 lg:pt-0 lg:pb-0" data-id="element-97">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full" data-id="element-98">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center" data-id="element-99">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex flex-col justify-center order-2 lg:order-1" data-id="element-100">
            <span className="text-sage font-bold tracking-wider uppercase text-sm mb-2 lg:mb-4 block" data-id="element-101">
              Transformación Natural
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif text-dark leading-tight mb-3 lg:mb-6" data-id="element-102">
              Eco-S.O.S. Detox: <br className="hidden md:block" data-id="element-103" />
              <span className="italic text-sage-dark" data-id="element-104">
                Recupera tu Energía en 7 Días
              </span>
            </h1>
            <h2 className="text-base md:text-xl text-dark/80 font-medium mb-3 lg:mb-6 leading-relaxed" data-id="element-105">
              Elimina los Químicos Ocultos que Sabotean tu Metabolismo y
              Desinfla tu Cuerpo
            </h2>
            <p className="text-sm md:text-lg text-dark/70 mb-5 lg:mb-8 leading-relaxed max-w-xl" data-id="element-106">
              Te despiertas cansada, con el abdomen hinchado, aunque comas sano
              y duermas bien. ¿Por qué no funciona nada? Hay un enemigo
              invisible en tu entorno diario, y hasta ahora se ha mantenido
              oculto. Pero hoy puedes eliminarlo.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-107">
              <button onClick={() => {
              const el = document.getElementById('pricing-cta');
              if (el) {
                el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }
            }} className="inline-flex items-center justify-center px-8 py-4 bg-sage hover:bg-sage-dark text-white rounded-full font-medium transition-all duration-300 shadow-lg shadow-sage/20 group" data-id="element-108">
                Obtén tu Detox Ahora
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-109" />
              </button>
            </div>
            <p className="text-sm text-dark/50 mt-3 lg:mt-4 flex items-center" data-id="element-110">
              <span className="w-2 h-2 rounded-full bg-sage mr-2" data-id="element-111"></span>
              Descarga inmediata y empieza hoy mismo tu transformación.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-112">
            <div className="relative w-full max-w-[240px] lg:max-w-lg mx-auto" data-id="element-113">
              <div className="absolute inset-0 bg-sage-light rounded-full blur-3xl opacity-50 transform -translate-x-1/4 translate-y-1/4" data-id="element-114"></div>
              <img src="https://cdn.magicpatterns.com/uploads/6z2upji7HUiqywbwX9LxZn/heylloyd-image-1776034671398.png" alt="Eco-S.O.S. Detox eBook en tablet" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-2xl" data-id="element-115" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}